import { mainSiteUrl } from "@/mocks/site";

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=An%20artistic%20abstract%20background%20with%20soft%20sage%20green%20and%20warm%20cream%20gradient%20shapes%2C%20subtle%20organic%20flowing%20forms%2C%20minimal%20clean%20aesthetic%2C%20gentle%20depth%20of%20field%2C%20high%20quality%20editorial%20style%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=basetao-hero-01&orientation=landscape"
          alt="Basetao Spreadsheet resource hub background"
          title="Basetao Spreadsheet product research hub"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center px-4 py-24 text-center md:px-6 md:py-32">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-background-50 backdrop-blur-sm">
          The Basetao Spreadsheet Resource Hub
        </span>

        <h1 className="mt-6 max-w-3xl font-heading text-3xl font-extrabold leading-tight tracking-tight text-background-50 md:text-5xl">
          Basetao Spreadsheet — Find Better Products, Check QC &amp; Plan Your Haul
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          Discover organized Basetao spreadsheet finds, product research, QC guidance, shipping
          resources and practical buyer guides — all in one place.
        </p>

        <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            Basetao Spreadsheet
            <i className="ri-arrow-right-up-line text-base" aria-hidden="true"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 sm:w-auto"
          >
            Buy It Now
            <i className="ri-shopping-bag-3-line text-base" aria-hidden="true"></i>
          </a>
        </div>

        <p className="mt-8 text-xs font-medium uppercase tracking-widest text-background-200">
          Independent Resource • Updated Guides • Multilingual Content
        </p>
      </div>
    </section>
  );
}